// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__Der38","logo":"navbar_logo__xA4-P","nav-list":"navbar_nav-list__5cdtk","nav-item":"navbar_nav-item__MV-UQ","icon-menu":"navbar_icon-menu__z9cnp"};